import React from 'react';
import { SubmitButtonProps } from './submit-button-type';
import { ClassicButton } from '../classic-button';

export const SubmitButton: React.FC<SubmitButtonProps> = (props: SubmitButtonProps) => {
    return <ClassicButton {...props} type="submit" />;
};
